import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
// import { AuthService } from './auth/auth.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { LoaderService } from '@app/services/shared/loader.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private router: Router,
        private loaderService: LoaderService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.showLoader();
        const currDateTime = new Date();
        if (localStorage.getItem('ng2Idle.main.expiry') && (JSON.parse(localStorage.getItem('ng2Idle.main.expiry')) > (currDateTime.getTime() - 300000)) && request.url.indexOf('oauth2/token') <= 0) {
        }
        return next.handle(request).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                this.hideLoader();
                // do stuff with response if you want
            }
        }, (err: any) => {
            this.hideLoader();
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    // redirect to the login route
                    localStorage.clear();
                    this.router.navigate(['/login']);
                }
            }
        });
    }

    private showLoader(): void {
        this.loaderService.show();
    }

    private hideLoader(): void {
        this.loaderService.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/base-service/tokenInterceptor.service.ts